import { render } from "./AvatarCrop.vue?vue&type=template&id=08fbb2a0"
import script from "./AvatarCrop.vue?vue&type=script&lang=js"
export * from "./AvatarCrop.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__